import { Provider } from "@redotech/redo-order-common/provider";
import * as z from "zod";

const SyncableProviderSchema = z.enum([
  Provider.SHOPIFY,
  Provider.BIGCOMMERCE,
  Provider.COMMENTSOLD,
  Provider.COMMERCE_CLOUD,
]);

export type SyncableProvider = z.infer<typeof SyncableProviderSchema>;

export const syncOrderByProviderId = {
  name: "syncOrderByProviderId" as const,
  input: z.object({
    provider: SyncableProviderSchema,
    orderIdentifier: z.string().min(1, "Order identifier is required"),
  }),
  output: z.object({ success: z.boolean() }),
};
